import { render, staticRenderFns } from "./BlackGoldJackpotBox.vue?vue&type=template&id=5aef9d7e&"
import script from "./BlackGoldJackpotBox.vue?vue&type=script&lang=js&"
export * from "./BlackGoldJackpotBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports